module.exports = __webpack_public_path__ + "static/media/dcc1212-60a.98c28dc1.jpg";